"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ImageGallery_exports = {};
__export(ImageGallery_exports, {
  default: () => ImageGallery_default
});
module.exports = __toCommonJS(ImageGallery_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.293 8.31641L16.457 13.8242H7.00391L9.36719 10.2891L10.8711 12.5547L13.293 8.31641ZM10.1484 7.14453C10.1484 7.47005 10.0312 7.75 9.79688 7.98438C9.57552 8.20573 9.30208 8.31641 8.97656 8.31641C8.65104 8.31641 8.37109 8.20573 8.13672 7.98438C7.90234 7.75 7.78516 7.47005 7.78516 7.14453C7.78516 6.81901 7.90234 6.53906 8.13672 6.30469C8.37109 6.07031 8.65104 5.95312 8.97656 5.95312C9.30208 5.95312 9.57552 6.07031 9.79688 6.30469C10.0312 6.53906 10.1484 6.81901 10.1484 7.14453ZM4.5625 4.80078C4.5625 4.20182 4.77083 3.69401 5.1875 3.27734C5.61719 2.84766 6.13151 2.63281 6.73047 2.63281H15.832C16.431 2.63281 16.9388 2.84766 17.3555 3.27734C17.7852 3.69401 18 4.20182 18 4.80078V13.9219C18 14.5208 17.7852 15.0352 17.3555 15.4648C16.9388 15.8815 16.431 16.0898 15.832 16.0898H6.73047C6.13151 16.0898 5.61719 15.8815 5.1875 15.4648C4.77083 15.0352 4.5625 14.5208 4.5625 13.9219V4.80078ZM6.73047 3.64844C6.40495 3.64844 6.125 3.76562 5.89062 4C5.66927 4.22135 5.55859 4.48828 5.55859 4.80078V13.9219C5.55859 14.2344 5.66927 14.5078 5.89062 14.7422C6.125 14.9635 6.40495 15.0742 6.73047 15.0742H15.832C16.1576 15.0742 16.431 14.9635 16.6523 14.7422C16.8867 14.5078 17.0039 14.2344 17.0039 13.9219V4.80078C17.0039 4.48828 16.8867 4.22135 16.6523 4C16.431 3.76562 16.1576 3.64844 15.832 3.64844H6.73047ZM6.00781 17.7695C5.20052 17.7695 4.51042 17.4896 3.9375 16.9297C3.36458 16.3568 3.07812 15.6667 3.07812 14.8594V6.57812C3.07812 6.46094 3.11719 6.36328 3.19531 6.28516C3.28646 6.20703 3.39062 6.16797 3.50781 6.16797C3.61198 6.16797 3.70312 6.20703 3.78125 6.28516C3.8724 6.36328 3.91797 6.46094 3.91797 6.57812V14.8594C3.91797 15.4323 4.11979 15.9271 4.52344 16.3438C4.92708 16.7474 5.42188 16.9492 6.00781 16.9492H14.2695C14.3867 16.9492 14.4844 16.9883 14.5625 17.0664C14.6536 17.1445 14.6992 17.2422 14.6992 17.3594C14.6992 17.4766 14.6536 17.5742 14.5625 17.6523C14.4844 17.7305 14.3867 17.7695 14.2695 17.7695H6.00781Z",
      fill: "currentColor"
    }
  )
);
const SvgImageGallery = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ImageGallery_default = SvgImageGallery;
